module.exports = __webpack_public_path__ + "static/media/Inter-ThinItalic.ae26e5b1.woff2";